export const convertMegabytesToBytes = (value: number): number => {
  const rate = 1048576
  return value * rate
}

export const convertBytesToKilobytes = (value: number): number => {
  const rate = 1024
  return value / rate
}

export function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export function formatNumber(value: number) {
  value = value.toString();
  const pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(value))
      value = value.replace(pattern, "$1,$2");
  return value;
}